<template>
  <CommentModeration type="product" :entity-id="$route.params.product_id || ''"/>
</template>

<script>
import CommentModeration from "@/views/includes/CommentModeration.vue";

export default { name: 'ProductCommentsList', components: { CommentModeration } }
</script>
